module.exports = __webpack_public_path__ + "img/Insta.c15b9152.svg";